module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAMAAADeWG8gAAAAaVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8G612AAAAInRSTlMA+fXxpAfs6cm8nYlpWzo2HRgP493Z0rarf3hTT0tCLSwmTsZB8gAAAHRJREFUGNNVztcOwCAIQFGqtXvvPfj/j6yQxuB9MHhMVPAyoU5bnxZETDzJ0Kal5EitQjaWUEjBkho7dg9LGZBMnR3rGJMG4GTpGzod7RRXleLHbqAimpWmNbhA3MGyw9+hfirAVUcsOYjegb/o1c4qM273AUzZDB1wOk73AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/tick.png
// module id = l3uH
// module chunks = 0